import { takeEvery, takeLatest } from 'redux-saga/effects';
import { createHashedTaasData, StreckenTarifierer } from '@ps20-frontend/preis-lib';
import { ForkEffect } from '@redux-saga/core/effects';

import { App } from '@ps20-frontend/frontend-models';
import {
  StreckenTarifierungRequestEvents,
  TARIF_CHECKED,
  ZUSATZOPTION_CHECKED,
  ZUSATZOPTION_UNCHECKED,
} from '@ps20-frontend/shop-integration-redux';
import { TaasThhHundData } from '@ps20/bff-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { ThhHundActions } from '../thhHundActions';
import { IAppState } from '../appState';
import { buildTaasThhHundDataForStrecke } from './transformer/thhHundData.transformer';

export let streckenTarifierer: StreckenTarifierer<IAppState, TaasThhHundData>;

export function* streckenTarifierungThhHund(): Generator<ForkEffect> {
  const requestActions = [
    TARIF_CHECKED,
    ZUSATZOPTION_CHECKED,
    ZUSATZOPTION_UNCHECKED,
    ThhHundActions.PREISE_REQUESTED,
    ThhHundActions.SELBSTBETEILIGUNG_CHANGED,
  ];
  const successActions = [
    StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_THH_HUND,
    StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_THH_HUND,
  ];

  streckenTarifierer = new StreckenTarifierer(
    {
      appId: App.THH_HUND,
      successEventWithInfo:
        StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_THH_HUND,
      successEventWithoutInfo:
        StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_THH_HUND,
      errorEvent: StreckenTarifierungRequestEvents.PREISE_REQUESTED_FAILED_THH_HUND,
    },
    buildTaasThhHundDataForStrecke,
    undefined,
    createHashedRelevantRiskdataTHH,
  );

  yield takeEvery(successActions, safeSaga(streckenTarifierer.handleSuccess, App.THH_HUND));
  yield takeEvery(
    StreckenTarifierungRequestEvents.PREISE_REQUESTED_FAILED_THH_HUND,
    safeSaga(streckenTarifierer.handleError, App.THH_HUND),
  );
  yield takeLatest(requestActions, safeSaga(streckenTarifierer.callTarifierung, App.THH_HUND));
}

export function createHashedRelevantRiskdataTHH(taasData: TaasThhHundData): string {
  const relevantData = { ...taasData };
  delete relevantData.salesProducts;
  delete relevantData.spartenType;

  return createHashedTaasData(relevantData);
}
